var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.selected_initiator,"items":_vm.initiators,"rules":_vm.initiatorRules,"item-value":"code","item-text":"description","label":_vm.label,"dense":"","clearable":_vm.isClearable},on:{"change":_vm.updateData}})
}
var staticRenderFns = []

export { render, staticRenderFns }